import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _181dc4dd = () => interopDefault(import('../pages/console.vue' /* webpackChunkName: "pages/console" */))
const _10ba8d22 = () => interopDefault(import('../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _4940a3a6 = () => interopDefault(import('../pages/new.vue' /* webpackChunkName: "pages/new" */))
const _2dfb1658 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _5f957cd5 = () => interopDefault(import('../pages/event/_eventId.vue' /* webpackChunkName: "pages/event/_eventId" */))
const _37e44f98 = () => interopDefault(import('../pages/event/_eventId/index.vue' /* webpackChunkName: "pages/event/_eventId/index" */))
const _524380b4 = () => interopDefault(import('../pages/event/_eventId/edit.vue' /* webpackChunkName: "pages/event/_eventId/edit" */))
const _915c9f92 = () => interopDefault(import('../pages/event/_eventId/edit/index.vue' /* webpackChunkName: "pages/event/_eventId/edit/index" */))
const _7c1a799f = () => interopDefault(import('../pages/event/_eventId/edit/report.vue' /* webpackChunkName: "pages/event/_eventId/edit/report" */))
const _0ddbc65e = () => interopDefault(import('../pages/event/_eventId/report.vue' /* webpackChunkName: "pages/event/_eventId/report" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/console",
    component: _181dc4dd,
    name: "console"
  }, {
    path: "/login",
    component: _10ba8d22,
    name: "login"
  }, {
    path: "/new",
    component: _4940a3a6,
    name: "new"
  }, {
    path: "/",
    component: _2dfb1658,
    name: "index"
  }, {
    path: "/event/:eventId?",
    component: _5f957cd5,
    children: [{
      path: "",
      component: _37e44f98,
      name: "event-eventId"
    }, {
      path: "edit",
      component: _524380b4,
      children: [{
        path: "",
        component: _915c9f92,
        name: "event-eventId-edit"
      }, {
        path: "report",
        component: _7c1a799f,
        name: "event-eventId-edit-report"
      }]
    }, {
      path: "report",
      component: _0ddbc65e,
      name: "event-eventId-report"
    }]
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
